import { render, staticRenderFns } from "./DoctorFeedbackList.vue?vue&type=template&id=04477ef2&scoped=true"
import script from "./DoctorFeedbackList.vue?vue&type=script&lang=js"
export * from "./DoctorFeedbackList.vue?vue&type=script&lang=js"
import style0 from "./DoctorFeedbackList.vue?vue&type=style&index=0&id=04477ef2&prod&lang=scss&scoped=true"
import style1 from "./DoctorFeedbackList.vue?vue&type=style&index=1&id=04477ef2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04477ef2",
  null
  
)

export default component.exports